module.exports = __webpack_public_path__ + "img/Lazlogo.dfd8cbcc.png";